/* Created by Interactive 63 - https://interactive63.com */
/**
 * Safe wrappers around localStorage. Storage can be blocked or full, so failures are swallowed
 * and the app simply behaves as though nothing was saved.
 */

/** Reads a value from localStorage, returning null when storage is unavailable. */
export function readStorage(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

/** Writes a value to localStorage, ignoring failures such as blocked storage. */
export function writeStorage(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Storage may be blocked or full; the setting simply will not persist.
  }
}
